import React, { useEffect, useRef, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ClosureOfTrandingWindow = () => {
  const pageid = 19; // <-- set pageid for closure of trading window
  const yearRefs = useRef({});
  const [closureData, setClosureData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClosureData = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setClosureData([]);
          setLoading(false);
          return;
        }

        // Group reports by year_name
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name;
          if (!grouped[year]) grouped[year] = [];
          grouped[year].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        // Convert grouped object to array and sort descending by year
        const finalData = Object.keys(grouped)
          .map((year) => ({
            year,
            reports: grouped[year],
          }))
          .sort((a, b) => b.year - a.year);

        setClosureData(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setClosureData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClosureData();
  }, []);

  // Scroll to first year automatically
  useEffect(() => {
    if (closureData.length > 0) {
      const el = yearRefs.current[closureData[0].year];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [closureData]);

  return (
    <>
      <Helmet>
        <title>Closure of Trading Window | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative bg-[#193267] mb-10 p-28 w-full px-32">
        <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
          Closure of Trading Window
        </h1>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading closure reports...</p>
        ) : closureData.length === 0 ? (
          <p>No closure reports found.</p>
        ) : (
          closureData.map((yearGroup, index) => (
            <div
              key={index}
              ref={(el) => (yearRefs.current[yearGroup.year] = el)}
              className="mb-10"
            >
              <h2 className="text-2xl font-extrabold text-[#0b3a6a] uppercase mb-4">
                For the Year {yearGroup.year}
              </h2>
              {yearGroup.reports.length === 0 ? (
                <p>No reports available for this year.</p>
              ) : (
                <ul className="list-disc pl-5 text-[#0b3a6a] font-medium space-y-2">
                  {yearGroup.reports.map((report, idx) => (
                    <li key={idx}>
                      <a
                        href={`${API_PDF_URL}/${report.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        {report.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
              <hr className="mt-4 border-gray-300" />
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default ClosureOfTrandingWindow;
